/*
 * Fast COD checkout flow.
 * On the main product page ONLY (not collection quick-add), intercept the
 * Add to Cart form submit, add the item via AJAX, then send the customer
 * straight to /pages/checkout instead of the normal cart drawer/page.
 * Uses a capturing listener on document so it reliably runs before Dawn's
 * own <product-form> submit handler, without editing that shared file.
 */
(function () {
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // Only the main product page form, never collection-grid quick add
      if (!form.closest('.product')) return;
      if (form.closest('.quick-add') || form.closest('quick-add-modal') || form.closest('quick-add-component')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtn = form.querySelector('[type="submit"], [name="add"]');
      var originalText = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      var formData = new FormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw new Error(err.description || err.message || 'Could not add this product to your cart.');
            });
          }
          return r.json();
        })
        .then(function () {
          window.location.href = root + 'pages/checkout';
        })
        .catch(function (err) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
          alert(err.message);
        });
    },
    true
  );

  /*
   * "Buy with Cash on Delivery" buttons on product listing cards
   * (homepage / collection grids). Adds the single item to the cart via
   * AJAX then jumps straight to the custom checkout page, same as the
   * main product page flow above. Multi-variant products instead open
   * the existing "choose options" quick-add modal, since a variant must
   * be picked first.
   */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cod-open-options]');
    if (openBtn) {
      var opener = openBtn.nextElementSibling;
      if (opener && opener.tagName === 'MODAL-OPENER') {
        var innerBtn = opener.querySelector('button');
        if (innerBtn) innerBtn.click();
      }
      return;
    }

    var buyBtn = e.target.closest('[data-cod-buy]');
    if (!buyBtn) return;

    var variantId = buyBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var originalHTML = buyBtn.innerHTML;
    buyBtn.disabled = true;
    var label = buyBtn.querySelector('.eoc-cod-label');
    if (label) label.textContent = 'Adding...';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error((err.description || err.message || 'Could not add this product to your cart.'));
          });
        }
        return r.json();
      })
      .then(function () {
        window.location.href = root + 'pages/checkout';
      })
      .catch(function (err) {
        buyBtn.disabled = false;
        buyBtn.innerHTML = originalHTML;
        alert(err.message);
      });
  });
})();
